export default __webpack_public_path__ + "static/media/X_Xui.6437e5bd.svg";